/**
 * API datalog.
 *
 * Beberapa tindakan mungkin dapat menghapus data-data penting dan tidak bisa dipulihkan.
 * Pastikan setiap tindakan dilakukan dengan aman.
 */

import request from '@/utils/request'
import { DataLog, Item, Query, QueryResult } from '@/types/data-log'

const baseURL = '/data-logger'

//---------------------------------------------------------------------------------------------------------------------------
// Datalog
//---------------------------------------------------------------------------------------------------------------------------

export function Find(q?: DataLog): Promise<DataLog[]> {
  return request.get(baseURL, { headers: { query: q } })
}

export function FindWithItems(q?: DataLog): Promise<DataLog[]> {
  return request.get(`${baseURL}?populate=items`, { headers: { query: q } })
}

export function Create(d: DataLog): Promise<DataLog> {
  return request.post(baseURL, d)
}

export function Patch(id: number, d: DataLog): Promise<DataLog> {
  return request.patch(`${baseURL}/${id}`, d)
}

/**
 * Hapus data dari database berdasarkan id-nya.
 *
 * **PERHATIAN!**
 *
 * proses ini akan menghapus konfigurasi datalog beserta item didalamnya secara permanen.
 *
 * Berkaitan dengan data yang sebelumnya telah direkam perlu didiskusikan lebih mendalam.
 *
 */
export function Delete(id: number): Promise<DataLog> {
  return request.delete(`${baseURL}/${id}`)
}

//---------------------------------------------------------------------------------------------------------------------------
// Datalog item
//---------------------------------------------------------------------------------------------------------------------------
export function CreateItem(item: Item): Promise<Item> {
  return request.post(`${baseURL}/item`, item)
}

export function FindItem(query?: Item): Promise<Item[]> {
  let url = '/data-logger/item'
  if (query) {
    // eslint-disable-next-line
    const urlQuery = new URLSearchParams(query as any).toString()
    url += `?${urlQuery}`
  }
  return request.get(url)
}

export function PatchItem(id: number, item: Item): Promise<Item> {
  return request.patch(`${baseURL}/item/${id}`, item)
}

export function DeleteItem(id: number): Promise<Item> {
  return request.delete(`${baseURL}/item/${id}`)
}

//---------------------------------------------------------------------------------------------------------------------------
// Routine controls
//---------------------------------------------------------------------------------------------------------------------------

/**
 * Start logger routine with specific id.
 *
 * Setelah routine berhasil jalan, proses perekaman data untuk setiap item data akan mulai dijalankan.
 * */
export function Start(id: number): Promise<DataLog> {
  return request.put(`${baseURL}/${id}?action=start`)
}

/**
 * Stop logger routine with specific id.
 *
 * Jika routine berhenti, maka proses perekaman data untuk semua item dihentikan.
 * */
export function Stop(id: number): Promise<DataLog> {
  return request.put(`${baseURL}/${id}?action=stop`)
}

//---------------------------------------------------------------------------------------------------------------------------
// Query recorded data
//---------------------------------------------------------------------------------------------------------------------------

export function QueryRecordedData(q: Query[]): Promise<QueryResult[][]> {
  return request.post(`${baseURL}/query`, q)
}
